<div *ngIf = "!token" class="login-body">
  <main class="main">
    <div class="login-section">
      <div class="login-img-sec">
        <img src="../../../../assets/img/login-bg.png" alt="login-bg">
        <div class="img-content">
          <h2>Refer Your Network and Get Referral Rewards including a <span class="text-theme">Ford Truck</span></h2>
          <p>When each of your referral signs up for AutoLeap, you will earn <span class="text-theme">$1,000!</span> Not just that, with every third successful referral sign up, you get a milestone giveaway all the way leading to a <span class="text-theme">Ford Truck</span> on your successful fifteenth referral sign up.</p>
          <a href="https://autoleap.com/referrals/" class="btn btn-orange">Refer Now</a>
        </div>
      </div>
      <div class="login-form-sec">
        <form>
          <div class="row justify-content-center mb-4">
            <div class="col-lg-6 col-md-10 col-8 logo">
              <img src="../../../../assets/alp_logo_transparent.png" class="img-fluid" alt="">
              <p *ngIf="state && state.errorMessage" class="duplicateSession">{{state.errorMessage}}</p>
              <p class="welcome">Sign in to continue</p>
            </div>
          </div>

          <div class="form-group">
            <app-input [id]="'login-email'" placeholder="Username" [errorMessage]="validate.userName" [isInvalid]="validate.userName"
              [value]="user.userName" [floatingLabel]="true" [autoFocus]="true"
              (appChange)="onChange('userName', $event)" (appFocus)="onFocus('userName')"></app-input>
          </div>

          <div class="form-group mb-15 mt-30">
            <app-input [id]="'login-password'" type="password" placeholder="Password" [hasShowPasswordIcon]="hasShowPasswordIcon" [errorMessage]="validate.password"
              [isInvalid]="validate.password" [value]="user.password" [floatingLabel]="isPasswordFloating"
              (appChange)="onChange('password', $event)" (appFocus)="onFocus('password')"></app-input>
          </div>

          <div class="row text-center">
            <div class="col-md-12">
              <span class="error-label" *ngIf="validate.general">{{validate.general}}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 text-center mt-20 mb-10">
              <button type="submit" (click)="onSubmit()" class="btn btn-block btn-primary btn-submit" [disabled]="isLoading">
                Sign in
                <i *ngIf="isLoading" class="fal fa-spinner rotate ml-1"></i>
              </button>
            </div>
            <p class="mt-auto pointer font-primary hover-underline" (click)="forgotPassword()" *ngIf="hasShowPasswordIcon">
              Forgot Password
            </p>
          </div>
        </form>
      </div>
    </div>
  </main>
</div>
<ngx-loading-bar></ngx-loading-bar>
